/* unplugin-vue-components disabled */const { ref, computed, nextTick, watchEffect } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "update-wrap" };
const _hoisted_2 = (0, vue_2.createElementVNode)("div", { class: "content-title-wrap" }, [
    (0, vue_2.createElementVNode)("span", null, "信号口"),
    (0, vue_2.createElementVNode)("span", { class: "remark-title" }, "注释"),
    (0, vue_2.createElementVNode)("span", null, "开关")
], -1);
const _hoisted_3 = { class: "io-list-wrap" };
const _hoisted_4 = {
    key: 0,
    class: "io-state-wrap"
};
const service_1 = require("@/rpc/service");
const model_1 = require("@/model");
const loading_1 = require("@/utils/loading");
const index_vue_1 = tslib_1.__importDefault(require("@/components/IoInput/index.vue"));
const ListItem_vue_1 = tslib_1.__importDefault(require("./ListItem.vue"));
const close_png_1 = tslib_1.__importDefault(require("@/assets/IoState/close.png"));
const open_png_1 = tslib_1.__importDefault(require("@/assets/IoState/open.png"));
const one_message_1 = require("@/utils/one_message");
const laborer_1 = require("@/store/modules/laborer");
const work_1 = require("@/store/modules/work");
exports.default = (0, vue_1.defineComponent)({
    __name: 'IoList',
    setup(__props, { expose: __expose }) {
        const lastUpdateTime = ref('');
        const robotService = (0, service_1.useRobotService)('elite');
        const ioList = computed(() => { var _a, _b; return (_b = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.curProgram.robot) === null || _b === void 0 ? void 0 : _b.code.ioList; });
        const outputIo = computed(() => { var _a; return (_a = ioList.value) === null || _a === void 0 ? void 0 : _a.filter(io => io.type === model_1.IO_TYPE.DO); });
        const inputIo = computed(() => { var _a; return (_a = ioList.value) === null || _a === void 0 ? void 0 : _a.filter(io => io.type === model_1.IO_TYPE.DI); });
        const laborerStore = (0, laborer_1.useLaborer)();
        let oldProjectId;
        const onRefresh = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            if (laborerStore.robotConnectState === 'connected' && laborerStore.mode !== 'prod') {
                one_message_1.oneMessage.warning('未正确连接机器人，请重新连接机器人！');
                return;
            }
            try {
                (0, loading_1.openLoading)({ text: "正在查询" });
                (_a = ioList.value) === null || _a === void 0 ? void 0 : _a.forEach((io) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    let ioName = Number(io.name.replace(/\D/g, ""));
                    let req;
                    if (io.type === model_1.IO_TYPE.DO) {
                        req = (yield robotService.getOutput(ioName));
                    }
                    else if (io.type === model_1.IO_TYPE.DI) {
                        req = (yield robotService.getInput(ioName));
                    }
                    if (!req)
                        return;
                    if (req.success) {
                        io.val = req.state;
                    }
                }));
                const currentDate = new Date();
                const hours = currentDate.getHours().toString().padStart(2, '0');
                const minutes = currentDate.getMinutes().toString().padStart(2, '0');
                const seconds = currentDate.getSeconds().toString().padStart(2, '0');
                lastUpdateTime.value = `${hours}:${minutes}:${seconds}`;
            }
            catch (e) {
                console.error(e);
            }
            finally {
                (0, loading_1.closeLoading)();
            }
        });
        const handleIoChange = (io) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            (0, loading_1.openLoading)({ text: '设置中' });
            try {
                let res = yield robotService.setOutput(Number(io.name.replace(/\D/g, "")), io.val);
                console.log(JSON.stringify(res) + io.val);
                if (!res.success) {
                    throw new Error(res.msg);
                }
            }
            catch (e) {
                io.val = io.val === 0 ? 1 : 0;
                one_message_1.oneMessage.error(e.message);
                console.error(e);
            }
            finally {
                (0, loading_1.closeLoading)();
            }
        });
        const workStore = (0, work_1.useWork)();
        const onIoNameChange = (item) => {
            nextTick(() => {
                workStore.notifyChangeIO(item);
            });
        };
        watchEffect(() => {
            var _a, _b;
            if (model_1.Project.current() && oldProjectId != ((_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.project_id) && laborerStore.robotConnectState === 'connected') {
                oldProjectId = (_b = model_1.Project.current()) === null || _b === void 0 ? void 0 : _b.project_id;
                onRefresh();
            }
        });
        __expose({
            refresh: onRefresh
        });
        return (_ctx, _cache) => {
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            const _component_el_text = (0, vue_2.resolveComponent)("el-text");
            const _component_el_image = (0, vue_2.resolveComponent)("el-image");
            const _component_el_switch = (0, vue_2.resolveComponent)("el-switch");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(_component_el_button, {
                        onClick: onRefresh,
                        icon: "Refresh",
                        size: "small"
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)("刷新")
                        ]),
                        _: 1
                    }),
                    (0, vue_2.createVNode)(_component_el_text, { class: "update-info" }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createTextVNode)("上次刷新：" + (0, vue_2.toDisplayString)((0, vue_2.unref)(lastUpdateTime)), 1)
                        ]),
                        _: 1
                    })
                ]),
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)([(0, vue_2.unref)(inputIo), (0, vue_2.unref)(outputIo)], (list, index) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ListItem_vue_1.default, {
                        key: `list${index}`,
                        class: "io-list"
                    }, {
                        header: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(index === 0 ? '输入信号口' : '输出信号口'), 1)
                        ]),
                        content: (0, vue_2.withCtx)(() => [
                            _hoisted_2,
                            (0, vue_2.createElementVNode)("div", _hoisted_3, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(list, (io) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        class: "io-item-wrap",
                                        key: `ioItem${io.id}`
                                    }, [
                                        (0, vue_2.createVNode)(index_vue_1.default, {
                                            model: io.name,
                                            "onUpdate:model": ($event) => ((io.name) = $event),
                                            item: io,
                                            onOnChange: ($event) => (onIoNameChange(io))
                                        }, null, 8, ["model", "onUpdate:model", "item", "onOnChange"]),
                                        (0, vue_2.createVNode)(_component_el_text, { class: "remark-content" }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(io.remark), 1)
                                            ]),
                                            _: 2
                                        }, 1024),
                                        (index === 0)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                                (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_image, {
                                                    class: "io-state-img",
                                                    src: (0, vue_2.unref)(close_png_1.default),
                                                    size: "15"
                                                }, null, 8, ["src"]), [
                                                    [vue_2.vShow, !io.val]
                                                ]),
                                                (0, vue_2.withDirectives)((0, vue_2.createVNode)(_component_el_image, {
                                                    class: "io-state-img",
                                                    src: (0, vue_2.unref)(open_png_1.default),
                                                    size: "15"
                                                }, null, 8, ["src"]), [
                                                    [vue_2.vShow, io.val]
                                                ])
                                            ]))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_switch, {
                                                key: 1,
                                                "inline-prompt": "",
                                                "active-text": "ON",
                                                "inactive-text": "OFF",
                                                "active-value": 1,
                                                "inactive-value": 0,
                                                modelValue: io.val,
                                                "onUpdate:modelValue": ($event) => ((io.val) = $event),
                                                size: "large",
                                                onChange: ($event) => (handleIoChange(io))
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                                    ]));
                                }), 128))
                            ])
                        ]),
                        _: 2
                    }, 1024));
                }), 128))
            ], 64));
        };
    }
});
